module.exports = __webpack_public_path__ + "static/media/sologo.07337020.png";